let authSessionRevision = 0
export const getAuthSessionRevision = () => authSessionRevision
const authSessionListeners = new Set()
export const subscribeAuthSession = (listener) => { authSessionListeners.add(listener); return () => authSessionListeners.delete(listener) }
export const invalidateAuthSession = () => {
  authSessionRevision += 1
  for (const listener of authSessionListeners) listener()
}

export const AUTH_TOKEN_STORAGE_KEY = 'user_auth_token'

const getWindowToken = () => {
  if (typeof window === 'undefined') return ''
  return window.__authToken || ''
}

export const getStoredAuthToken = () => {
  try {
    return (
      sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ||
      localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ||
      getWindowToken()
    )
  } catch (error) {
    try {
      return sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || getWindowToken()
    } catch (fallbackError) {
      return getWindowToken()
    }
  }
}

export const persistAuthToken = (token) => {
  if (!token) return
  if (getStoredAuthToken() !== token) invalidateAuthSession()

  try {
    sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token)
  } catch (error) {}

  try {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token)
  } catch (error) {}

  try {
    window.__authToken = token
  } catch (error) {}
}

export const clearPersistedAuthToken = () => {
  invalidateAuthSession()
  try {
    sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY)
  } catch (error) {}

  try {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY)
  } catch (error) {}

  try {
    delete window.__authToken
  } catch (error) {
    try {
      window.__authToken = ''
    } catch (fallbackError) {}
  }
}
